import Phaser from 'phaser';
import { AudioManager } from '../Scripts/Systems/AudioManager';
import { DiscordRichPresenceManager } from '../Scripts/Systems/DiscordRichPresenceManager';

export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super('MainMenuScene');
  }

  public create(): void {
    DiscordRichPresenceManager.updatePresence('In Main Menu', 'Preparing Adventure');
    const { width, height } = this.scale;

    // Gradient Background
    const graphics = this.add.graphics();
    graphics.fillGradientStyle(0x0f172a, 0x1e1b4b, 0x311b92, 0x4a148c, 1);
    graphics.fillRect(0, 0, width, height);

    // Parallax background preview elements
    this.add.image(width / 2, height / 2, 'bg_mountains').setScale(2.5).setAlpha(0.4);

    // Title Text
    this.add.text(width / 2, 160, 'THE FORGOTTEN RUINS', {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '42px',
      color: '#facc15',
      stroke: '#000000',
      strokeThickness: 8,
    }).setOrigin(0.5);

    this.add.text(width / 2, 230, '16-Bit Modern Retro Platformer', {
      fontFamily: 'Outfit, sans-serif',
      fontSize: '22px',
      color: '#38bdf8',
    }).setOrigin(0.5);

    // Start Button Prompt
    const startText = this.add.text(width / 2, 350, '[ PRESS SPACE TO PLAY ]', {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '20px',
      color: '#4ade80',
    }).setOrigin(0.5);

    this.tweens.add({
      targets: startText,
      alpha: 0.2,
      duration: 600,
      yoyo: true,
      repeat: -1,
    });

    // Developer Level Editor Button
    const editorBtn = this.add.text(width / 2, 415, '🛠️ DEVELOPER EDITOR (Press E or F1)', {
      fontFamily: '"Press Start 2P", monospace',
      fontSize: '14px',
      color: '#facc15',
      backgroundColor: '#1e293b',
      padding: { x: 16, y: 10 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    editorBtn.on('pointerover', () => editorBtn.setStyle({ color: '#ffffff', backgroundColor: '#3b82f6' }));
    editorBtn.on('pointerout', () => editorBtn.setStyle({ color: '#facc15', backgroundColor: '#1e293b' }));
    editorBtn.on('pointerdown', () => this.scene.start('LevelEditorScene'));

    // Controls Box
    const controlsBg = this.add.rectangle(width / 2, 560, 680, 130, 0x090a10, 0.85);
    controlsBg.setStrokeStyle(2, 0x3b82f6);

    const controlsText = [
      'CONTROLS:',
      '• Walk: A/D or Left/Right Arrow  |  Run: Hold SHIFT',
      '• Jump / Double Jump / Wall Jump: SPACE or W / Up Arrow',
      '• Wall Slide: Move against wall in air  |  Climb Vine: W/S or Up/Down',
      '• Developer Mode: Press E / F1 to open Level Editor anytime',
    ].join('\n');

    this.add.text(width / 2, 560, controlsText, {
      fontFamily: 'Outfit, sans-serif',
      fontSize: '15px',
      color: '#cbd5e1',
      align: 'center',
      lineSpacing: 6,
    }).setOrigin(0.5);

    // Input Triggers
    if (this.input.keyboard) {
      this.input.keyboard.once('keydown-SPACE', () => {
        AudioManager.playSFX('jump');
        AudioManager.startBGM();
        this.scene.start('GameScene');
      });

      this.input.keyboard.on('keydown-E', () => {
        this.scene.start('LevelEditorScene');
      });
      this.input.keyboard.on('keydown-F1', () => {
        this.scene.start('LevelEditorScene');
      });
    }
  }
}
